import React from "react";

export const Cilindrada = ({ filtrar }) => {
  return (
    <div className="c-modal-1__section">
      <div className="c-modal-1__heading">Cilindrada</div>
      <div className="c-modal-1__item">
        <div className="c-list-6">
          <div className="c-list-6__item">
            <div className="o-form-check">
              <input
                className="o-form-check__campo--v2"
                id="check-cilindrada-hasta"
                type="radio"
                name="cilindrada__check"
                value1="''"
                value2="125"
                btn_name="Hasta 125 cc"
                onClick={filtrar}
              />
              <label htmlFor="check-cilindrada-hasta">
                <span className="c-form-1__text-2">Hasta 125 cc</span>
              </label>
            </div>
          </div>
          <div className="c-list-6__item">
            <div className="o-form-check">
              <input
                className="o-form-check__campo--v2"
                id="check-cilindrada-rango"
                type="radio"
                name="cilindrada__check"
                value1="125"
                value2="160"
                btn_name="125 a 160 cc"
                onClick={filtrar}
              />
              <label htmlFor="check-cilindrada-rango">
                <span className="c-form-1__text-2">125 a 160 cc</span>
              </label>
            </div>
          </div>
          <div className="c-list-6__item">
            <div className="o-form-check">
              <input
                className="o-form-check__campo--v2"
                id="check-cilindrada-desde"
                type="radio"
                name="cilindrada__check"
                value1="160"
                value2="''"
                btn_name="Más de 160 cc"
                onClick={filtrar}
              />
              <label htmlFor="check-cilindrada-desde">
                <span className="c-form-1__text-2">Más de 160 cc</span>
              </label>
              <input type="hidden" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
